import { type Connection } from '@blaze-shared/workflow-domain';

export function getRemovedWorkflowIds(
  savedConnections: Connection[],
  currentConnections: Connection[],
): string[] {
  // Find all unique workflow ids that were referenced in the connections as they were saved on the server
  const referencedWorkflowIds = new Set<string>();
  savedConnections.forEach((connection) => {
    if (connection.source.layerType === 'Workflow') {
      referencedWorkflowIds.add(connection.source.id);
    }
    if (connection.target.layerType === 'Workflow') {
      referencedWorkflowIds.add(connection.target.id);
    }
  });

  // Find all unique workflow ids that are referenced in the connections as they are now
  const currentReferencedWorkflowIds = new Set<string>();
  currentConnections.forEach((connection) => {
    if (connection.source.layerType === 'Workflow') {
      currentReferencedWorkflowIds.add(connection.source.id);
    }
    if (connection.target.layerType === 'Workflow') {
      currentReferencedWorkflowIds.add(connection.target.id);
    }
  });

  const workflowsToRemove = new Set<string>();
  referencedWorkflowIds.forEach((id) => {
    if (!currentReferencedWorkflowIds.has(id)) {
      workflowsToRemove.add(id);
    }
  });

  return Array.from(workflowsToRemove);
}
